import { render, staticRenderFns } from "./UkStep4.vue?vue&type=template&id=23cb00ad"
import script from "./UkStep4.vue?vue&type=script&lang=js"
export * from "./UkStep4.vue?vue&type=script&lang=js"
import style0 from "./UkStep4.vue?vue&type=style&index=0&id=23cb00ad&prod&lang=less"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports